module.exports = __webpack_public_path__ + "static/6-2f103bc67de0077e2da0a70cd1b7b175.png";